
import Vue from 'vue'

export default Vue.extend({
  name: 'AccountButtons',
  computed: {
    isSignedIn() {
      return this.$store.state.authentication.signedIn
    },
    userName() {
      return this.$store.state.authentication.user.firstname
    },
    avatar() {
      return this.$store.state.authentication.user.avatar
    },
    nickname() {
      return this.$store.state.authentication.user.nickname
    },
    isAmbasador() {
      return this.$store.state.authentication.user.isAmbasador
    },
  },
  data: () => ({}),
  methods: {
    signOut: function () {
      this.$store.dispatch('authentication/signOut', {
        api: this.$api,
      })
    },
  },
})
